import updeep from 'updeep';
import { map, keyBy } from 'lodash';
import api from '@src/util/api';
import { setApplications } from './applications';

export const SET_APPLICANTS = `${__dirname}/setApplicants`;
export const fetchApplicants = openingId => {
  return async dispatch => {
    let { applicants } = await api(`/api/v2/openings/${openingId}/applicants`);

    const applications = keyBy(
      map(applicants, ({ application, user, contacts }) => ({
        application,
        applicationId: application._id,
        contacts,
        user,
      })),
      'application._id',
    );

    dispatch(setApplications(applications));

    applicants = updeep.updateIn('*.application', application => application._id, applicants);

    dispatch({
      applicants,
      openingId,
      type: SET_APPLICANTS,
    });

    return applicants;
  };
};
